export default __webpack_public_path__ + "static/media/logo_guillespers.7b8e01ca.svg";